// src/components/GlobalFirmaDialog.tsx
import { useEffect, useState } from "react";
import FirmaDialog from "./FirmaDialog";

export default function GlobalFirmaDialog() {
  const [open, setOpen] = useState(false);
  const [reservaId, setReservaId] = useState<number | null>(null);

  useEffect(() => {
    const h = (e: Event) => {
      const det = (e as CustomEvent).detail || {};
      if (det?.reservaId) {
        setReservaId(Number(det.reservaId));
        setOpen(true);
      }
    };
    window.addEventListener("dialog:firma:open", h as EventListener);
    return () => window.removeEventListener("dialog:firma:open", h as EventListener);
  }, []);

  if (!open || reservaId == null) return null;
  return (
    <FirmaDialog
      open={open}
      reservaId={reservaId}
      onClose={() => {
        setOpen(false);
        setReservaId(null);
      }}
    />
  );
}
